<app-nav [titulo]="owner ? 'Modificar propietario ' + getOwnerName(owner) : 'Nuevo propietario'" [descripcion]="owner ? 'Aquí podrá ver todos los detalles del propietario seleccionado y modificarlos.' : 'Por favor complete todos los datos del nuevo propetario.'">
    <div class="edit-owner basic-avm-editor">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab [label]="owner ? 'Edición' : 'Creación manual'">
                <form class="edit-owner-form" [formGroup]="ownerFG">
                    <mat-horizontal-stepper class="form-stepper" [linear]="!owner" #stepper>
                        <mat-step [completed]="!!broker" *ngIf="showBrokerSelectionStep">
                            <div class="form-step broker-selector">
                                <ng-template matStepLabel>Agente asociado</ng-template>
                                <h3 class="form-step-title">
                                    Agente
                                </h3>
                                <span class="form-step-description">
                                    Debe seleccionar el agente asociado a la cotización.
                                </span>
                                <button mat-raised-button color="primary" type="button" class="garantor-button mini select-broker-button" (click)="openSelectBrokerModal()" *ngIf="!broker">
                                    Seleccionar agente
                                </button>
                                <div class="selected-broker" *ngIf="broker">
                                    <span class="broker-name">{{ broker.nombre }} {{ broker.apellido }}</span>
                                    <button mat-icon-button type="button" class="delete-broker-button" color="accent" (click)="broker = undefined" [disabled]="owner">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                                <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="stepper.next()" *ngIf="broker">
                                    Siguiente
                                </button>
                            </div>
                        </mat-step>
                        <mat-step [completed]="isGeneralSectionValid()">
                            <div class="form-step general-form-step">
                                <ng-template matStepLabel>Información general</ng-template>
                                <h3 class="form-step-title">
                                    Información general
                                </h3>
                                <span class="form-step-description">
                                    Para comenzar complete la información del propietario.
                                </span>
                                <mat-radio-group class="form-radio-line" formControlName="tipoPersona" color="primary">
                                    <span class="radio-line-label">
                                        Tipo de persona
                                    </span>
                                    <div class="radios">
                                        <mat-radio-button value="FISICA">Persona física</mat-radio-button>
                                        <mat-radio-button value="JURIDICA">Persona jurídica</mat-radio-button>
                                    </div>
                                </mat-radio-group>
                                <div class="form-line">
                                    <mat-form-field class="garantor-form-field" appearance="outline">
                                        <mat-label>Código</mat-label>
                                        <input matInput formControlName="codigo">
                                        <mat-error *ngIf="ownerFG.controls.codigo.hasError('required')">
                                            Por favor ingrese un código
                                        </mat-error>
                                        <mat-error *ngIf="ownerFG.controls.codigo.hasError('notAvailable')">
                                            El valor seleccionado no está disponible
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="garantor-form-field" appearance="outline">
                                        <mat-label>E-Mail</mat-label>
                                        <input matInput formControlName="email">
                                        <mat-error *ngIf="ownerFG.controls.email.hasError('required')">
                                            Por favor ingrese el email
                                        </mat-error>
                                        <mat-error *ngIf="ownerFG.controls.email.hasError('email')">
                                            Por favor ingrese un email válido
                                        </mat-error>
                                        <mat-hint>
                                            Este email será utilizado para notificaciones
                                        </mat-hint>
                                    </mat-form-field>
                                </div>
                                <app-physical-person-form [formGroup]="physicalPersonFG" [personType]="personType"></app-physical-person-form>
                                <app-legal-person-form [formGroup]="legalPersonFG" [personType]="personType"></app-legal-person-form>
                                <div class="form-step-buttons">
                                    <button mat-raised-button color="primary" class="garantor-button next" (click)="isGeneralSectionValid() && stepper.next()">Siguiente</button>
                                    <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOwner()" *ngIf="owner">Guardar y salir</button>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step [completed]="isRepresentativeSectionValid()">
                            <div class="form-step representative-form-step">
                                <ng-template matStepLabel>Representante</ng-template>
                                <h3 class="form-step-title">
                                    Representante
                                </h3>
                                <span class="form-step-description">
                                    Complete los datos del representante (si corresponde).
                                </span>
                                <app-representative-form [formGroup]="representativeFG" [personType]="personType"></app-representative-form>
                                <div class="form-step-buttons">
                                    <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                    <button mat-raised-button color="primary" class="garantor-button next" (click)="isRepresentativeSectionValid() && stepper.next()">Siguiente</button>
                                    <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOwner()" *ngIf="owner">Guardar y salir</button>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step [completed]="isAddressSectionValid()">
                            <div class="form-step address-form-step">
                                <ng-template matStepLabel>Dirección</ng-template>
                                <h3 class="form-step-title">
                                    Dirección
                                </h3>
                                <span class="form-step-description">
                                    Complete los datos de la dirección del propietario.
                                </span>
                                <app-address-form [formGroup]="addressFG"></app-address-form>
                                <div class="form-step-buttons">
                                    <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                    <button mat-raised-button color="primary" class="garantor-button next" (click)="isAddressSectionValid() && stepper.next()">Siguiente</button>
                                    <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOwner()" *ngIf="owner">Guardar y salir</button>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step>
                            <div class="form-step details-form-step">
                                <ng-template matStepLabel>Resumen</ng-template>
                                <h3 class="form-step-title">
                                    Resumen
                                </h3>
                                <span class="form-step-description">
                                    Por favor verifique los datos del nuevo propietario y presione confirmar.
                                </span>
                                <div class="owner-details-content-container">
                                    <app-owner-details-content [owner]="getResultingOwner()"></app-owner-details-content>
                                </div>
                                <div class="form-step-buttons">
                                    <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                    <button mat-raised-button color="accent" type="button" class="garantor-button submit" (click)="createOwner()">Confirmar</button>
                                </div>
                            </div>
                        </mat-step>
                    </mat-horizontal-stepper>
                </form>
            </mat-tab>
            <mat-tab label="Creación masiva" *ngIf="!owner">
                <app-bulk-creator style="width: 100%;" [columnMaps]="bulkCreatorColumnMaps" [getErrorsFn]="getBulkCreatorErrors" [submitFn]="bulkCreatorSubmit"></app-bulk-creator>
            </mat-tab>
        </mat-tab-group>
    </div>
</app-nav>
